import type { AxiosError } from 'axios'
import type { Mutation } from 'react-query'
import { showNotification } from 'src/components/parts/notifications/notifications'

interface BackendMessageError {
    error?: { message?: string }
}

export const getErrorMessage = (error: unknown): string =>
    ((error as AxiosError)?.response?.data as BackendMessageError)?.error?.message ?? 'An unexpected error occurred'

// Mutations that handle their own errors opt out with `meta: { silent: true }`
export const handleMutationError = (
    ...[error, , , mutation]: [unknown, unknown, unknown, Mutation<unknown, unknown, unknown, unknown>]
) => {
    if (mutation.meta?.silent) {
        return
    }
    showNotification('error', getErrorMessage(error))
}
